// System permissions
export const Permissions = {
  // Course modules
  CreateModules: 'Modules.Create',
  DeleteModules: 'Modules.Delete',
  EditModules: 'Modules.Edit',

  // Course permissions
  ViewCourses: 'Courses.View',
  ManageCourses: 'Courses.Manage',
  CreateCourses: 'Courses.Create',
  EditCourses: 'Courses.Edit',
  DeleteCourses: 'Courses.Delete',

  // Content permissions
  ViewContent: 'Content.View',
  ManageContent: 'Content.Manage',
  CreateContent: 'Content.Create',
  EditContent: 'Content.Edit',
  DeleteContent: 'Content.Delete',

  // Quiz permissions
  ViewQuizzes: 'Quizzes.View',
  ManageQuizzes: 'Quizzes.Manage',
  CreateQuizzes: 'Quizzes.Create',
  EditQuizzes: 'Quizzes.Edit',
  DeleteQuizzes: 'Quizzes.Delete',

  // Brand permissions
  ViewBrands: 'Brands.View',
  ManageBrands: 'Brands.Manage',

  // Learning Path permissions
  ViewLearningPaths: 'LearningPaths.View',
  ManageLearningPaths: 'LearningPaths.Manage',
  CreateLearningPaths: 'LearningPaths.Create',
  EditLearningPaths: 'LearningPaths.Edit',
  DeleteLearningPaths: 'LearningPaths.Delete',

  // My courses permissions (for employees)
  ViewMyCourses: 'MyCourses.View',
  ViewMyProgress: 'MyProgress.View',

  // Progress permissions (for supervisors)
  ViewProgress: 'Progress.View',
  ValidateProgress: 'Progress.Validate',
  EditProgress: 'Progress.Edit',
} as const;

// Type for permission values
export type Permission = typeof Permissions[keyof typeof Permissions];

// Helper function to check if a string is a valid permission
export const isValidPermission = (permission: string): permission is Permission => {
  return Object.values(Permissions).includes(permission as Permission);
};

